var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"text-no-decoration filter-item",class:_vm.isMobile && 'mobile',on:{"click":_vm.toggleFilter}},[(_vm.isMobile)?_c('div',{staticClass:"d-flex flex-align-center item-content"},[_c('span',[_vm._v(_vm._s(_vm.label))])]):_c('span',[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }